import { push, goBack, replace, goForward, go } from 'connected-react-router';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
export default (function () {
    var dispatch = useDispatch();
    var action = useCallback(function (path, state) { return dispatch(push(path, state)); }, [
        dispatch,
    ]);
    var handleAction = useCallback(function (path, state) { return function () { return action(path, state); }; }, [
        action,
    ]);
    var goAction = useCallback(function (index) { return dispatch(go(index)); }, [dispatch]);
    var handleGoAction = useCallback(function (index) { return function () { return goAction(index); }; }, [goAction]);
    var goBackAction = useCallback(function () { return dispatch(goBack()); }, [dispatch]);
    var handleGoBackAction = useCallback(function () { return goBackAction(); }, [goBackAction]);
    var goForwardAction = useCallback(function () { return dispatch(goForward()); }, [dispatch]);
    var handleGoForwardAction = useCallback(function () { return goForwardAction(); }, [goForwardAction]);
    var replaceAction = useCallback(function (path, state) { return dispatch(replace(path, state)); }, [
        dispatch,
    ]);
    var handleReplaceAction = useCallback(function (path, state) { return function () { return replaceAction(path, state); }; }, [replaceAction]);
    return {
        push: action,
        handlePush: handleAction,
        go: goAction,
        handleGo: handleGoAction,
        goBack: goBackAction,
        handleGoBack: handleGoBackAction,
        goForward: goForwardAction,
        handleGoForward: handleGoForwardAction,
        replace: replaceAction,
        handleReplace: handleReplaceAction,
    };
});
//# sourceMappingURL=useHistory.js.map